module.exports = __webpack_public_path__ + "img/pintec.c5e2f4a5.png";